"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubjectCategoryEnum = void 0;
var SubjectCategoryEnum;
(function (SubjectCategoryEnum) {
  /** спец-категория для "Другая дисциплина" */
  SubjectCategoryEnum[SubjectCategoryEnum["other_subject"] = 0] = "other_subject";
  /** без категории */
  SubjectCategoryEnum[SubjectCategoryEnum["non_categorized"] = 1] = "non_categorized";
  /** иностранный язык */
  SubjectCategoryEnum[SubjectCategoryEnum["foreign_language"] = 2] = "foreign_language";
  /** родной язык */
  SubjectCategoryEnum[SubjectCategoryEnum["native_language"] = 3] = "native_language";
  /**
   * @deprecated
   * @see native_language
   */
  SubjectCategoryEnum[SubjectCategoryEnum["language"] = 3] = "language";
  /** Пользовательская дисциплина */
  SubjectCategoryEnum[SubjectCategoryEnum["user_subject"] = 4] = "user_subject";
})(SubjectCategoryEnum = exports.SubjectCategoryEnum || (exports.SubjectCategoryEnum = {}));
var SubjectsRegistryTypes = function () {
  var o = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    o[_i] = arguments[_i];
  }
  return o;
}('other',
// = дисциплины категории SubjectCategoryEnum.other_subject
'user',
// = дисциплины категории SubjectCategoryEnum.user_subject
'native',
// = дисциплины категории SubjectCategoryEnum.native_language
'foreign',
// = дисциплины категории SubjectCategoryEnum.foreign_language
'non_categorized',
// = дисциплины категории SubjectCategoryEnum.non_categorized
'recent');
